exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background {\n  height: 100dvh;\n  width: 100vw;\n  --tw-bg-opacity: 1;\n  background-color: rgb(55 65 81 / var(--tw-bg-opacity));\n  background-size: cover;\n  background-position: center\n}", ""]);

// exports
